import { safeNumberFormat } from '@localization/safeIntl';

/**
 * Formats an amount in minor units as currency, deriving the fraction digits from the
 * currency itself — JPY has none, so a hardcoded 2 would be 100x off.
 *
 * Lives here rather than in `@apps/stays/components/OfferSummary/utils` so callers do not
 * inherit that module's graph (`date-fns`, `date-fns-tz`, `DiscountsProvider`, the onsite
 * charge-name maps) just to format one number. `OfferSummary/utils` re-exports it.
 *
 * Falls back to the raw minor units if the locale or currency is not recognised, so a bad
 * code degrades to something visible instead of throwing.
 */
export const formatMinorUnitsAsCurrency = (minorUnits: number, currency: string, locale: string): string => {
  try {
    const formatter = safeNumberFormat(locale, { style: 'currency', currency });
    const divisor = Math.pow(10, formatter.resolvedOptions().maximumFractionDigits ?? 2);
    return formatter.format(minorUnits / divisor);
  } catch {
    return String(minorUnits);
  }
};
